export const BasketPermissionsArray = [
    'BASKET',
    'BASKET_DIGIT_PROC',
    'BASKET_NET_PRICES',
    'BASKET_NET_PRICES_PR',
    'BASKET_NET_PRICES_SP',
    'BASKET_ORDER',
    'BASKET_QUOTATION',
    'BASKET_SAMPLE_ORDER',
] as const;

export const OSPermissionsArray = [
    'API_ESIS',
    'BASIC',
    'BASIC_CUS',
    'BILL_OF_MATERIAL',
    'CDM',
    'DATA_AND_DOCUMENTS',
    'DC_NET_PRICES',
    'DOWNLOAD_SCE_CHAR',
    'DR',
    'DRAM',
    'DR_ADMIN',
    'DR_ASSETLIST',
    'DR_BETA',
    'DR_DASHBOARD',
    'DR_PARAMPLOT',
    'DR_RULE_EDIT',
    'DR_SERVICE',
    'DR_VISU',
    'ECS',
    'ECS_BOM_DETAIL',
    'ECS_LIST',
    'FC_EDITOR',
    'FORM_CLAIM',
    'IM',
    'IM_SRV_FIELD',
    'IM_SRV_INHOUSE',
    'PEXW',
    'PEXW_ADMIN',
    'PEXW_EMPL_WW',
    'PEXW_OVERVIEW',
    'PO_NEW_DELV',
    'PO_ORDER',
    'PO_PDF_PRICES',
    'PO_QUOTATION',
    'PO_REJECT',
    'PO_SAMPLE',
    'PO_SERVICE',
    'PROCESS_OVERVIEW',
    'PROJECT_ROOMS',
    'ROOMS',
    'SPARE_PART_LIST',
    'SPARE_PART_SELECTION',
    'STREAM',
    'SUPPORT_CATALOGS',
    'TEC_DATA_ON_ORDER_CO',
    'UNPROTECTED_PDF',
    'USER_ADMINISTRATION',
    'VM',
    'VM2020',
    ...BasketPermissionsArray,
] as const;

export type OSPermission = (typeof OSPermissionsArray)[number];

export type BasketPermission = (typeof BasketPermissionsArray)[number];

export function isBasketPermission(value: string): value is BasketPermission {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return BasketPermissionsArray.includes(value as any);
}

export function isOSPermission(value: string): value is OSPermission {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return OSPermissionsArray.includes(value as any);
}

export type OSPermissions = OSPermission[];

export type BasketPermissions = BasketPermission[];
